import { connect } from 'react-redux';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_STRUCTURE_OPTIONS } from '@Pages/RetroSynthesis/StructureOption/constants';
import {
  clearStateAction,
  fetchSynthesisPlannerMenuOptionsAction,
  structureOptionClearAction,
} from '@Pages/RetroSynthesis/StructureOption/actions';
import { openWith3d } from '@Containers/StructureDialog/StructureDialogAction';
import StructureOptionContainer from './StructureOptionContainerBase';

const mapStateToProps = (state) => {
  const { targetRect, data, optionType, synthesisMenuOptions, trackingContext, routeType } = state
    .get(REDUCER_KEY_RS)
    .get(REDUCER_KEY_STRUCTURE_OPTIONS);
  return { targetRect, data, optionType, synthesisMenuOptions, trackingContext, routeType };
};

const mapDispatchToProps = {
  clearStateAction,
  structureOptionClearAction,
  fetchSynthesisPlannerMenuOptionsAction,
  openStructureIn3dAction: openWith3d,
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureOptionContainer);
